<!-- 입대업체 그룹을 수정하거나 등록하는 팝업입니다. -->
<template>
  <v-dialog v-model="show" persistent max-width="600px">
    <!-- 다이얼로그 내부 -->
    <v-card>
      <!-- 타이틀 -->
      <v-card-title>
        <span class="headline">{{ titleComputed | translate }}</span>
      </v-card-title>
      <!-- 임대업체 그룹 정보 입력 필드 -->
      <v-card-text>
        <v-container>
          <!-- 그룹명 입력 필드 -->
          <v-row class="mb-5">
            <v-text-field
              v-model="editItem.groupName"
              label="그룹명"
              rows="1" hide-details outlined
            />
          </v-row>

          <!-- 임대업체 목록 -->
          <div class="d-flex" style="height: 200px; margin-bottom: 15px">
            <!-- 미사용 임대업체 목록 -->
            <rental-company-list
                :title="'미사용 임대업체 목록' | translate"
                :items="companiesNotInGroup"
                :selected-items.sync="selectedItemsNotInGroup"
            />

            <div style="display: block; ">
              <div class="switching-btn">
                <v-btn @click="onAddInGroup">
                  {{ '추가' | translate }}
                </v-btn>
              </div>
              <div class="switching-btn">
                <v-btn @click="onRemoveInGroup">
                  {{ '삭제' | translate }}
                </v-btn>
              </div>
            </div>
            <!-- 사용중인 임대업체 목록 -->
            <rental-company-list
                :title="'사용중인 임대업체 목록' | translate"
                :items="companiesInGroup"
                :selected-items.sync="selectedItemsInGroup"
            />
          </div>

          <!-- 삭제여부 필드 -->
          <v-row>
            <v-checkbox
                v-model="isEditItemDeleted"
                :label="'삭제여부'|translate"
                class="mb-5"
                hide-details
                :disabled="deleteYnDisabled"
            />
          </v-row>

          <!-- 메모 입력 필드 -->
          <v-row class="mb-5">
            <v-textarea
              v-model="editItem.memo"
              label="메모"
              rows="10" hide-details outlined
            />
          </v-row>
        </v-container>
      </v-card-text>

      <!-- 팝업 취소, 확인 버튼 -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- 확인 버튼 -->
        <v-btn color="green darken-1"
           text
           :disabled="validItem"
           @click="saveData"
        >
          {{ '확인'|translate }}
        </v-btn>
        <!-- 팝업 데이터를 초기화 하고 닫습니다. -->
        <v-btn color="red darken-1" text @click="onClose">
          {{ '취소' | translate }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {CODE} from "@/model/code";
import {cloneDeep} from "lodash";
import {PATH} from "@/constants";
import RentalCompanyList from "@/views/rental-company/manager/group/RentalCompanyList.vue";
export default {
  name: "RentalCompanyGroupPopup",
  components: {RentalCompanyList},

  props: {
    // 입대업체 그룹 정보 아이템
    item: {
      type: Object,
      default: undefined
    },
    // 버튼 타입
    buttonType:{
      type: String,
      default: undefined
    },
    // 버튼 텍스트
    buttonText:{
      type: String,
      default: undefined,
    },
    // 팝업 보이기 여부
    show:{
      type: Boolean,
      default: false,
    },
    // 아이템 삭제여부 비활성화
    deleteYnDisabled:{
      type: Boolean,
      default: false,
    },
    // 전체 임대업체 목록
    rentalCompanies:{
      type: Array,
      default:()=>([])
    },
  },

  data() {
    return {
      // 수정 아이템
      editItem: {
        rentalcompanyGroupId: undefined,
        groupName: undefined,
        memo: undefined,
        deleteYn: false,
      },
      // 등록 성공 메시지
      registerSuccessText: this.$translate('등록되었습니다.'),
      // 등록 실패 메시지
      registerFailText: this.$translate('등록이 실패했습니다.'),
      // 수정 성공 메시지
      editSuccessText: this.$translate('수정되었습니다.'),
      // 수정 실패 메시지
      editFailText: this.$translate('수정이 실패했습니다.'),
      tableRefresher: 0,
      // 그룹내 임대업체 목록
      companiesInGroup: [],
      selectedItemsInGroup: [],
      // 그룹외 임대업체 목록
      companiesNotInGroup: [],
      selectedItemsNotInGroup: [],
      // 사용중인 업체 목록 수정 여부
      isEditedUsingRentalCompanies: false,
    }
  },

  computed: {
    /**
     * 팝업 제목
     * @returns {string}
     */
    titleComputed() {
      if(this.buttonType === CODE.POPUP_TYPE.REGISTER){
        return '새 임대업체 그룹 추가'
      }
      if(this.buttonType === CODE.POPUP_TYPE.EDIT){
        return '임대업체 그룹 수정'
      }

      return 'invalid buttonType'
    },

    /**
     * 아이템이 저장 가능한지 검증합니다.
     * @returns {boolean} T: 저장가능 / F: 저장불가능
     */
    validItem() {
      // 저장불가로 초기화
      let valid = false

      // 수정 아이템 데이터
      const editMemo = this.editItem ? this.editItem.memo : undefined
      const editGroupName = this.editItem ? this.editItem.groupName : undefined

      // 원본 데이터
      const itemMemo = this.item ? this.item.memo : undefined
      const itemGroupName = this.item ? this.item.groupName : undefined

      // 그룹명이 비어있으면 invalid
      valid = !this.isEmptyString(editGroupName)

      // 기존 내용과 다른 점이 없으면 invalid
      if (this.buttonType === CODE.POPUP_TYPE.EDIT){
        valid = (editMemo !== itemMemo)           // 메모가 수정되었을 경우
            || (editGroupName !== itemGroupName)  // 그룹명이 수정되었을 경우
            || this.isEditedUsingRentalCompanies  // 임대업체 목록 변경이 감지된 경우
            || this.isEditItemDeleted !== this.isItemDeleted // 삭제여부가 수정되었을 경우
      }

      return !valid
    },

    /**
     * 수정 아이템의 삭제 여부
     */
    isEditItemDeleted:{
      get(){
        return this.editItem.deleteYn === 'Y'
      },
      set(newValue){
        this.editItem.deleteYn = newValue ? 'Y' : 'N'
      },
    },

    /**
     * 기존 아이템의 삭제 여부
     */
    isItemDeleted(){
      if(!this.item) return false

      return this.item.deleteYn === 'Y'
    },
  },

  watch: {
    item: {
      immediate: true,
      handler(newValue) {
        if(!newValue) return

        // 수정 아이템 초기화
        this.clearEditItem(newValue)
      }
    },

    companiesInGroup:{
      immediate:true,
      deep:true,
      handler(newValue){
        this.companiesNotInGroup = this.getRentalCompaniesNotInGroup(newValue)
      }
    },

    /**
     * 팝업 보이기
     * @param newValue
     */
    show(newValue){
        if(!newValue){
          // 창이 닫힐 때 데이터를 초기화 합니다.
          this.clearEditItem(this.item)
        }else{
          this.companiesNotInGroup = this.getRentalCompaniesNotInGroup(this.companiesInGroup)
        }

    },
  },

  methods: {

    /**
     * 수정 항목을 초기화 합니다.
     */
    clearEditItem(item){
      if (item) {
        // item 이 있을 경우 item 으로 초기화
        this.editItem = cloneDeep(item)
        this.companiesInGroup = cloneDeep(item.usingRentalCompanies)
        if(!this.companiesInGroup){
          this.companiesInGroup = []
        }
      } else {
        // 없을 경우 undefined로 초기화
        this.editItem.groupName = undefined
        this.editItem.memo = undefined
        this.companiesInGroup = []
      }

      this.selectedItemsInGroup = []
      this.selectedItemsNotInGroup = []

      // 임대업체 목록을 초기화 합니다.
      // this.tableRefresher++
    },

    /**
     * 문자열이 비어있는지 확인합니다.
     * @param item 확인대상 (문자열)
     * @returns {boolean}
     */
    isEmptyString(item){
      return !item || item.trim() === ''
    },

    /**
     * 그룹에 포함되지 않은 임대업체 목록을 반환합니다.
     * @param companiesInGroup
     * @returns {*[]}
     */
    getRentalCompaniesNotInGroup(companiesInGroup){
      if(!this.rentalCompanies || !this.rentalCompanies[0]){
        return []
      }

      if(!companiesInGroup || !companiesInGroup[0]){
        // 그룹내 포함된 임대업체가 없으면 전체 목록을 반환합니다.
        return cloneDeep(this.rentalCompanies)
      }else{
        // 젠체 목록에서 그룹에 포함된 임대업체를 제외하고 반환합니다.
        return this.rentalCompanies.filter(el => {
          return !companiesInGroup.find(inGroup => inGroup.rentalcompanyId === el.rentalcompanyId)
        })
      }
    },

    /**
     * 데이터를 저장합니다.
     */
    saveData() {
      const params = {
        ...this.editItem,
        usingRentalCompanies: this.companiesInGroup,
      }

      if (this.buttonType === CODE.POPUP_TYPE.REGISTER) {
        // 신규 등록 요청
        this.saveRequest(
            PATH.RANTALCOMPANY_GROUP.ADD,
            params,
            this.registerSuccessText,
            this.registerFailText
        )
      } else if (this.buttonType === CODE.POPUP_TYPE.EDIT) {

        if(!this.updateValidation()) return

        // 수정 요청
        this.saveRequest(
            PATH.RANTALCOMPANY_GROUP.UPDATE,
            params,
            this.editSuccessText,
            this.editFailText
        )
      }else{
        console.error('save data feature has not been assigned unknown button type >> ', this.buttonType)
      }
    },

    /**
     * 데이터 저장 요청 메서드 입니다.
     * 요청 후 (성공, 실패) alert 을 출력하고
     * 성공 시 이벤트를 발생시키고 팝업을 닫습니다.
     * @param url 요청 Url
     * @param reqBody 요청 바디 정보
     * @param successText 성곰 메시지
     * @param errorText 에러 메시지
     */
    async saveRequest(url, reqBody, successText, errorText){
      const res = await this.$request(url)
          .setObject(reqBody)
          .enqueue()

      if(res){
        // 저장완료 이벤트 발생
        this.$emit('saved-complete')
        // 성공 메시지
        alert(successText)
      }else{
        // 실패 메시지
        alert(errorText)
      }

      // 팝업 닫기
      this.onClose()
    },


    onRemoveInGroup() {
      const result = this.swapItems(this.selectedItemsInGroup, this.companiesInGroup, this.companiesNotInGroup)
      this.companiesInGroup = result.fromItems
      this.companiesNotInGroup = result.toItems
      this.selectedItemsInGroup = []
    },

    onAddInGroup(){
      const result = this.swapItems(this.selectedItemsNotInGroup, this.companiesNotInGroup, this.companiesInGroup)
      this.companiesNotInGroup = result.fromItems
      this.companiesInGroup = result.toItems
      this.selectedItemsNotInGroup = []
    },

    /**
     * 팝업 닫기
     */
    onClose(){
      this.$emit('update:show', false)
    },

    /**
     * 선택된 목록을 목적지 목록으로 데이터를 옮깁니다.
     * @param selectedItems 선택된 목록
     * @param fromItems 출처 목록
     * @param toItems 목적지 목록
     * @returns {{toItems, fromItems}} 수정된 목록 반환
     */
    swapItems(selectedItems, fromItems, toItems){
      // 선택된 목록이 없을 경우 그냥 반환
      if (!selectedItems || !selectedItems[0]) {
        return {
          fromItems,
          toItems,
        }
      }

      // 출처 목록에서 선택된 목록 제거
      fromItems = fromItems.filter(e=>{
        return !selectedItems.find(selectedItem=>selectedItem.rentalcompanyId === e.rentalcompanyId)
      })

      // 목적지 목록으로 병합
      toItems = toItems.concat(selectedItems)

      // 목록 이동 감지
      this.isEditedUsingRentalCompanies = true;

      // 변환된 내용 반환
      return {
        fromItems,
        toItems,
      }
    },


    /**
     * 수정 요청 전 데이터 검증
     * @returns {boolean}
     */
    updateValidation(){
      let valid = true
      if(!this.editItem.rentalcompanyGroupId){
        console.error('invalid rentalcompantGroupId >> ', this.editItem.rentalcompanyGroupId)
        alert(this.$translate('오류로 인해 저장할 수 없습니다.'))
        valid = false
      }else if(this.isDeleteItemChanged()){
        valid = false
        // 삭제여부가 체크이고 기존의 삭제여부가 false 였을 경우 알림 띄우기
        this.$confirm(this.$translate('임대업체 그룹을 삭제하시겠습니까?'))
            .then(()=>valid = true)
      }
      return valid
    },

    isDeleteItemChanged(){
      return this.deleteYnDisabled && this.item && !this.item.deleteYn
    },

  },
}
</script>

<style scoped>
.switching-btn{
  padding: 10px
}
</style>
